import { render, staticRenderFns } from "./examineEnroll.vue?vue&type=template&id=36163404"
import script from "./examineEnroll.vue?vue&type=script&lang=js"
export * from "./examineEnroll.vue?vue&type=script&lang=js"
import style0 from "./examineEnroll.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports